import * as React from 'react';
import { SurveyVersionDataService } from '../../services';
import { SurveyVersion } from '../../models';
import { TopNavMenu } from '../navigation/TopNavMenu';
import { TopNavMenuItem } from '../navigation/TopNavMenuItem';
import { NavLink } from 'react-router-dom';
import { ListingState, BaseRouteProps } from '../../interfaces';

export class SurveyVersionListing extends React.Component<BaseRouteProps<{}>, ListingState<SurveyVersion>> {
    private surveyVersionDataService = new SurveyVersionDataService(this.props.notificationService);

    constructor(props: BaseRouteProps<{}>) {
        super(props);

        this.state = {
            entities: new Array<SurveyVersion>(),
        };
    }

    public componentDidMount() {
        this.surveyVersionDataService.getAll().then((surveyVersions: SurveyVersion[]) => {
            this.setState(
                { entities: surveyVersions }
            );
        });
    }

    public render() {
        return (
            <div>
                <TopNavMenu open={true}>
                    <TopNavMenuItem to="/surveyVersion/create">
                        <span className="glyphicon glyphicon-plus" />
                    </TopNavMenuItem>
                </TopNavMenu>

                <div className="content-header">
                    <div className="content-container">
                        <h1>Survey Versions</h1>
                    </div>
                </div>

                <div className="content-body">
                    <div className="content-container">
                        <table className="table">
                            <thead>
                                <tr>
                                    <td>Survey Key</td>
                                    <td>User</td>
                                    <td>Completed</td>
                                    <td>Expires</td>
                                    <td />
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.entities.map((entity, index) => {
                                    return <tr key={index}>
                                        <td />
                                        <td />
                                        <td />
                                        <td />
                                        <td>
                                            <NavLink className="btn btn-primary" to={`/surveyVersion/${entity.id}`}>View</NavLink>
                                        </td>
                                    </tr>;
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>);
    }
}



// WEBPACK FOOTER //
// ./src/components/surveyversion/SurveyVersionListing.tsx